const content = [
	{
		schoolName: "Universitety of Kadri Zeka - Gjilan",
		fieldStudy: "Computer Science",
		dates: {
			startYear: "2016",
		},
	},
	{
		schoolName: "Gjimnazi Zenel Hajdini",
		fieldStudy: "Shkenca Natyrore",
		dates: {
			startYear: "2011",
			endYear: "2014",
		},
	},
];

export default content;